import store from "@/store";
import makePermission from "@/permissions/makePermission";

export default makePermission((group: string): {
    hasPermission: () => Promise<boolean>;
} => {
    const state: any = store.state;

    return {
        hasPermission() {
            return Promise.resolve(
                store.getters["auth/isSuperUser"] ||
                    state.auth.user.groups.includes(group)
            );
        }
    };
});
